import React, { Fragment } from 'react';
import ListBox from '../../../../../../components/outline/ListBox';
import Button from '../../../../../../components/Button';
import Table from '../../../../../../components/_table/Table';
import { _LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import columns from './columns';
import './OrderCancelManagementList.scss';

const OrderCancelManagementList = (props) => {
  const {
    orderCancelManagementList,
    orderCancelManagementSelectedList,
    getList,
    onCheckOrderItem,
    getAllListExcelDownload,
    getSelectedListExcelDownload,
    rejectOrderCancel,
    getOrderCancelStockAndStatusList,
    rejectOrderCancelDeliveryDispatch,
  } = props;
  const { list, filterOption, pagination } = orderCancelManagementList;

  return (
    <ListBox
      className="order-cancel-management-list"
      head={
        <div className="excel-btn-area">
          <Button isRadius={true} text="선택 주문 엑셀 다운로드" onClick={() => getSelectedListExcelDownload()} />
          <Button isRadius={true} text="전체 주문 엑셀 다운로드" onClick={() => getAllListExcelDownload()} />
        </div>
      }
      body={
        <Fragment>
          <div className="order-cancel-management-list-body-area">
            <div className="full-btn-area">
              <div className="button-form">
                <div className="label">취소 처리</div>
                <div className="button-list">
                  <Button text="취소 거부 처리" onClick={() => rejectOrderCancel()} />

                  <Button text="취소 완료 처리" onClick={() => getOrderCancelStockAndStatusList()} />

                  <Button text="취소 거부 -> 발송 처리" onClick={() => rejectOrderCancelDeliveryDispatch()} />
                </div>
              </div>
            </div>
          </div>

          <Table
            className="order-cancel-management-list-table"
            rowKey={(record) => record.orderItemId}
            list={list}
            onCheck={(data) => onCheckOrderItem(data)}
            selectedList={orderCancelManagementSelectedList}
            initialOption={{
              pagination: _LIST_PAGINATION_MODEL,
            }}
            filterOption={filterOption}
            pagination={pagination}
            getList={getList}
            scroll={{ x: true }}
            columns={(utils) => columns(utils)}
          />
        </Fragment>
      }
    />
  );
};

export default OrderCancelManagementList;
